import { useState } from 'react';
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Tooltip,
    Fab,
} from '@mui/material';
import { addNewContainer } from '../../api/stationsApi';
import AddIcon from "@mui/icons-material/Add";


export default function AddScenarioContainerDialog({ token, onSuccess }) {
    const [open, setOpen] = useState(false);
    const [scenarioName, setScenarioName] = useState('');


    const createScenarioContainer = async () => {
        const res = await addNewContainer(scenarioName, token);
        onSuccess?.();
        return res;
    };


    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);
    };


    return (
        <>
            <Tooltip title="Dodaj nowy scenariusz">
                <Fab
                    color="primary"
                    size="small"
                    variant="contained"
                    aria-label="add to shopping cart"
                    sx={{ ml: 2 }}
                    onClick={handleOpen}
                >
                    <AddIcon />
                </Fab>
            </Tooltip>

            <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
                <DialogTitle>Dodaj nowy scenariusz</DialogTitle>

                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Nazwa scenariusza"
                        fullWidth
                        value={scenarioName}
                        onChange={(e) => setScenarioName(e.target.value)}
                    />
                </DialogContent>


                <DialogActions>
                    <Button onClick={handleClose}>Anuluj</Button>
                    <Button variant="contained" onClick={() => { createScenarioContainer(scenarioName); handleClose(); }}>
                        Dodaj
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
